// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1Wpfk","inputWrap":"styles_inputWrap__1Egca","input":"styles_input__1s-aJ"};